import React, { Component } from 'react';
import { Paper } from '@mui/material';
import { connect, ConnectedProps } from 'react-redux';
import { injectIntl } from 'react-intl';
import { IntlState } from 'react-intl-redux';
import Heading from './Heading';
import { showHelp } from '../../redux/actions';

type Props = {
  title: any;
  children: React.ReactNode;
  intl: IntlState;
  show: boolean;
  elevation?: number;
} & ReduxTypes;

class ContentBox extends Component<Props> {
  render() {
    const { show = true } = this.props;
    if (!show) {
      return '';
    }

    const {
      title,
      children,
      elevation,
      intl,
      showHelp: showHelpAction,
    } = this.props;

    // check if we got a help text for this content box
    const helpTitleId = title.props && `${title.props.id}.helpTitle`;
    const helpAvailable = helpTitleId && intl.messages[helpTitleId];
    return (
      <Paper
        elevation={elevation}
        className="pa3"
        square
      >
        <Heading
          title={title}
          onHelp={
            helpAvailable
              ? () => showHelpAction(title.props.id)
              : undefined
          }
        />
        <div className="mb3" />
        {children}
      </Paper>
    );
  }
}

const mapStateToProps = () => ({});

const dispatchProps = {
  showHelp,
};

type ReduxTypes = ConnectedProps<typeof connector>;

const connector = connect(mapStateToProps, dispatchProps);
export default injectIntl(connector(ContentBox));
